import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const RoundLinkIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.4717 13.8233L18.4717 13.8232L18.4643 13.8157C18.4044 13.7559 18.4153 13.6817 18.4568 13.6416L18.4569 13.6417L18.4643 13.6343C20.698 11.4005 20.6996 7.76982 18.4632 5.54468C16.2311 3.32372 12.6012 3.30914 10.3747 5.54681C8.15392 7.77875 8.13916 11.4083 10.3763 13.6348C10.4356 13.6946 10.4246 13.7684 10.3833 13.8084L10.3832 13.8083L10.3758 13.8157C10.3159 13.8756 10.2417 13.8647 10.2017 13.8233L10.2017 13.8232L10.1943 13.8157C7.85815 11.4796 7.85934 7.68014 10.1935 5.3551C12.5309 3.0268 16.3309 3.02037 18.6549 5.35344C20.9816 7.68918 20.9816 11.4799 18.6458 13.8157C18.5859 13.8756 18.5117 13.8647 18.4717 13.8233Z"
        fill="#292D32"
        stroke="#475569"
        strokeWidth="1.2"
      />
      <path
        d="M5.52836 10.1768L5.5283 10.1768L5.53574 10.1843C5.59562 10.2442 5.58472 10.3183 5.54325 10.3584L5.54318 10.3583L5.53574 10.3657C3.30201 12.5995 3.30048 16.2302 5.5368 18.4553C7.76893 20.6763 11.3988 20.6909 13.6253 18.4532C15.8461 16.2213 15.8609 12.5917 13.6237 10.3652C13.5644 10.3054 13.5754 10.2316 13.6168 10.1917L13.6168 10.1917L13.6243 10.1843C13.6842 10.1244 13.7583 10.1353 13.7984 10.1768L13.7983 10.1768L13.8057 10.1843C16.1419 12.5204 16.1407 16.3199 13.8066 18.6449C11.4692 20.9732 7.66909 20.9797 5.34509 18.6466C3.01844 16.3108 3.01844 12.5201 5.35427 10.1843C5.41415 10.1244 5.48832 10.1353 5.52836 10.1768Z"
        fill="#292D32"
        stroke="#475569"
        strokeWidth="1.2"
      />
    </SvgIcon>
  )
}
